// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/vault/v1/vault.proto" (package "c1.api.vault.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { VaultOpenerService } from "./vault";
import type { VaultOpenerServiceOpenResponse } from "./vault";
import type { VaultOpenerServiceOpenRequest } from "./vault";
import { AppVaultBindingService } from "./vault";
import type { AppVaultBindingServiceListResponse } from "./vault";
import type { AppVaultBindingServiceListRequest } from "./vault";
import type { AppVaultBindingServiceDeleteResponse } from "./vault";
import type { AppVaultBindingServiceDeleteRequest } from "./vault";
import type { AppVaultBindingServiceCreateResponse } from "./vault";
import type { AppVaultBindingServiceCreateRequest } from "./vault";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { VaultService } from "./vault";
import type { VaultServiceGetUserCanViewVaultsResponse } from "./vault";
import type { VaultServiceGetUserCanViewVaultsRequest } from "./vault";
import type { VaultServiceSetOwnersResponse } from "./vault";
import type { VaultServiceSetOwnersRequest } from "./vault";
import type { VaultServiceListOwnersResponse } from "./vault";
import type { VaultServiceListOwnersRequest } from "./vault";
import type { VaultServiceSearchVaultsForOwnerResponse } from "./vault";
import type { VaultServiceSearchVaultsForOwnerRequest } from "./vault";
import type { VaultServiceSearchResponse } from "./vault";
import type { VaultServiceSearchRequest } from "./vault";
import type { VaultServiceUpdateResponse } from "./vault";
import type { VaultServiceUpdateRequest } from "./vault";
import type { VaultServiceDeleteResponse } from "./vault";
import type { VaultServiceDeleteRequest } from "./vault";
import type { VaultServiceCreateResponse } from "./vault";
import type { VaultServiceCreateRequest } from "./vault";
import type { VaultServiceGetResponse } from "./vault";
import type { VaultServiceGetRequest } from "./vault";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { VaultServiceListResponse } from "./vault";
import type { VaultServiceListRequest } from "./vault";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.vault.v1.VaultService
 */
export interface IVaultServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: VaultServiceListRequest, options?: RpcOptions): UnaryCall<VaultServiceListRequest, VaultServiceListResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: VaultServiceGetRequest, options?: RpcOptions): UnaryCall<VaultServiceGetRequest, VaultServiceGetResponse>;
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: VaultServiceCreateRequest, options?: RpcOptions): UnaryCall<VaultServiceCreateRequest, VaultServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: VaultServiceDeleteRequest, options?: RpcOptions): UnaryCall<VaultServiceDeleteRequest, VaultServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: VaultServiceUpdateRequest, options?: RpcOptions): UnaryCall<VaultServiceUpdateRequest, VaultServiceUpdateResponse>;
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: VaultServiceSearchRequest, options?: RpcOptions): UnaryCall<VaultServiceSearchRequest, VaultServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: SearchVaultsForOwner
     */
    searchVaultsForOwner(input: VaultServiceSearchVaultsForOwnerRequest, options?: RpcOptions): UnaryCall<VaultServiceSearchVaultsForOwnerRequest, VaultServiceSearchVaultsForOwnerResponse>;
    /**
     * @generated from protobuf rpc: ListOwners
     */
    listOwners(input: VaultServiceListOwnersRequest, options?: RpcOptions): UnaryCall<VaultServiceListOwnersRequest, VaultServiceListOwnersResponse>;
    /**
     * @generated from protobuf rpc: SetOwners
     */
    setOwners(input: VaultServiceSetOwnersRequest, options?: RpcOptions): UnaryCall<VaultServiceSetOwnersRequest, VaultServiceSetOwnersResponse>;
    /**
     * @generated from protobuf rpc: GetUserCanViewVaults
     */
    getUserCanViewVaults(input: VaultServiceGetUserCanViewVaultsRequest, options?: RpcOptions): UnaryCall<VaultServiceGetUserCanViewVaultsRequest, VaultServiceGetUserCanViewVaultsResponse>;
}
/**
 * @generated from protobuf service c1.api.vault.v1.VaultService
 */
export class VaultServiceClient implements IVaultServiceClient, ServiceInfo {
    typeName = VaultService.typeName;
    methods = VaultService.methods;
    options = VaultService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: VaultServiceListRequest, options?: RpcOptions): UnaryCall<VaultServiceListRequest, VaultServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceListRequest, VaultServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: VaultServiceGetRequest, options?: RpcOptions): UnaryCall<VaultServiceGetRequest, VaultServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceGetRequest, VaultServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: VaultServiceCreateRequest, options?: RpcOptions): UnaryCall<VaultServiceCreateRequest, VaultServiceCreateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceCreateRequest, VaultServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: VaultServiceDeleteRequest, options?: RpcOptions): UnaryCall<VaultServiceDeleteRequest, VaultServiceDeleteResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceDeleteRequest, VaultServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: VaultServiceUpdateRequest, options?: RpcOptions): UnaryCall<VaultServiceUpdateRequest, VaultServiceUpdateResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceUpdateRequest, VaultServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: VaultServiceSearchRequest, options?: RpcOptions): UnaryCall<VaultServiceSearchRequest, VaultServiceSearchResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceSearchRequest, VaultServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchVaultsForOwner
     */
    searchVaultsForOwner(input: VaultServiceSearchVaultsForOwnerRequest, options?: RpcOptions): UnaryCall<VaultServiceSearchVaultsForOwnerRequest, VaultServiceSearchVaultsForOwnerResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceSearchVaultsForOwnerRequest, VaultServiceSearchVaultsForOwnerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListOwners
     */
    listOwners(input: VaultServiceListOwnersRequest, options?: RpcOptions): UnaryCall<VaultServiceListOwnersRequest, VaultServiceListOwnersResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceListOwnersRequest, VaultServiceListOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetOwners
     */
    setOwners(input: VaultServiceSetOwnersRequest, options?: RpcOptions): UnaryCall<VaultServiceSetOwnersRequest, VaultServiceSetOwnersResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceSetOwnersRequest, VaultServiceSetOwnersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetUserCanViewVaults
     */
    getUserCanViewVaults(input: VaultServiceGetUserCanViewVaultsRequest, options?: RpcOptions): UnaryCall<VaultServiceGetUserCanViewVaultsRequest, VaultServiceGetUserCanViewVaultsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultServiceGetUserCanViewVaultsRequest, VaultServiceGetUserCanViewVaultsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.vault.v1.AppVaultBindingService
 */
export interface IAppVaultBindingServiceClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AppVaultBindingServiceCreateRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceCreateRequest, AppVaultBindingServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppVaultBindingServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceDeleteRequest, AppVaultBindingServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppVaultBindingServiceListRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceListRequest, AppVaultBindingServiceListResponse>;
}
/**
 * @generated from protobuf service c1.api.vault.v1.AppVaultBindingService
 */
export class AppVaultBindingServiceClient implements IAppVaultBindingServiceClient, ServiceInfo {
    typeName = AppVaultBindingService.typeName;
    methods = AppVaultBindingService.methods;
    options = AppVaultBindingService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: AppVaultBindingServiceCreateRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceCreateRequest, AppVaultBindingServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppVaultBindingServiceCreateRequest, AppVaultBindingServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: AppVaultBindingServiceDeleteRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceDeleteRequest, AppVaultBindingServiceDeleteResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppVaultBindingServiceDeleteRequest, AppVaultBindingServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: AppVaultBindingServiceListRequest, options?: RpcOptions): UnaryCall<AppVaultBindingServiceListRequest, AppVaultBindingServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AppVaultBindingServiceListRequest, AppVaultBindingServiceListResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.vault.v1.VaultOpenerService
 */
export interface IVaultOpenerServiceClient {
    /**
     * @generated from protobuf rpc: Open
     */
    open(input: VaultOpenerServiceOpenRequest, options?: RpcOptions): UnaryCall<VaultOpenerServiceOpenRequest, VaultOpenerServiceOpenResponse>;
}
/**
 * @generated from protobuf service c1.api.vault.v1.VaultOpenerService
 */
export class VaultOpenerServiceClient implements IVaultOpenerServiceClient, ServiceInfo {
    typeName = VaultOpenerService.typeName;
    methods = VaultOpenerService.methods;
    options = VaultOpenerService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Open
     */
    open(input: VaultOpenerServiceOpenRequest, options?: RpcOptions): UnaryCall<VaultOpenerServiceOpenRequest, VaultOpenerServiceOpenResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<VaultOpenerServiceOpenRequest, VaultOpenerServiceOpenResponse>("unary", this._transport, method, opt, input);
    }
}
